import React, { useRef, useMemo, useState } from 'react';

import { FormControlLabel, Checkbox } from '@material-ui/core';
import { Form } from '@unform/web';
import { format } from 'date-fns';
import { isEmpty, includes } from 'lodash';
import PropTypes from 'prop-types';

import { Table } from '~/components';
import { DateTime, Input } from '~/components/Form';
import { t } from '~/helpers';

import * as S from './styles';

export default function ItemDetail({ data }) {
  const formRef = useRef(null);

  const [modify, setModify] = useState(false);

  const header = useMemo(() => {
    const labelAfter =
      !isEmpty(data) && data.acaoauditoriasistema === 'A'
        ? t('s.geral.opcoes.valor')
        : t('s.relatorio.auditoria.valordepois');

    const headerData = [
      {
        id: 'codigolabelsistema',
        label: t('s.relatorio.auditoria.campo'),
        format: (value) => t(value),
        style: (value) =>
          value.diferencacampoauditoriaitemsistema === 'S' &&
          data.acaoauditoriasistema === 'U'
            ? { background: 'rgba(245, 0, 87, 0.08)' }
            : {},
      },
      {
        id: 'valornovoauditoriaitemsistema',
        label: labelAfter,
        style: (value) =>
          value.diferencacampoauditoriaitemsistema === 'S' &&
          data.acaoauditoriasistema === 'U'
            ? { background: 'rgba(245, 0, 87, 0.08)' }
            : {},
      },
    ];

    if (!isEmpty(data) && data.acaoauditoriasistema !== 'A') {
      headerData.splice(1, 0, {
        id: 'valorantigoauditoriaitemsistema',
        label: t('s.relatorio.auditoria.valorantes'),
        style: (value) =>
          value.diferencacampoauditoriaitemsistema === 'S' &&
          data.acaoauditoriasistema === 'U'
            ? { background: 'rgba(245, 0, 87, 0.08)' }
            : {},
      });
    }

    return headerData;
  }, [data]);

  const options = useMemo(
    () => [
      { label: 'A', value: t('s.geral.botaoacesso') },
      { label: 'I', value: t('s.geral.botaoincluir') },
      { label: 'U', value: t('s.geral.botaoalterar') },
      { label: 'D', value: t('s.geral.botaoexcluir') },
      { label: 'R', value: t('s.geral.botaorelatorio') },
    ],
    []
  );

  const initialData = useMemo(
    () =>
      isEmpty(data)
        ? {}
        : {
            ...data,
            datahoraauditoriasistema: format(
              data.datahoraauditoriasistema,
              'dd-MM-yyyy HH:mm'
            ),
            acaoauditoriasistema: options.find(
              (o) => o.label === data.acaoauditoriasistema
            ).value,
          },
    [data]
  );

  if (!isEmpty(data))
    return (
      <Form ref={formRef} initialData={initialData}>
        <S.Wrapper>
          <DateTime
            disabled
            time
            name="datahoraauditoriasistema"
            label={t('s.relatorio.auditoria.datahora')}
          />

          <Input
            disabled
            name="cadastroauditoriasistema"
            label={t('s.relatorio.auditoria.cadastroauditoriasistema')}
          />

          <Input
            disabled
            name="chaveauditoriasistema"
            label={t('s.relatorio.auditoria.chaveauditoriasistema')}
          />

          <Input
            disabled
            name="acaoauditoriasistema"
            label={t('s.relatorio.auditoria.acaoauditoriasistema')}
          />

          <Input
            disabled
            name="codigousuario"
            label={t('s.relatorio.reltransferencia.codigousuario')}
          />

          <Input
            disabled
            name="nomeusuario"
            label={t('s.geral.camposistema.nomeusuario')}
          />

          {data.acaoauditoriasistema === 'U' && (
            <FormControlLabel
              label={t('s.relatorio.auditoria.exibirativos')}
              control={
                <Checkbox
                  checked={modify}
                  onChange={() => setModify(!modify)}
                  color="primary"
                />
              }
            />
          )}
        </S.Wrapper>

        <Table
          cells={header}
          data={data.items.filter((item) =>
            modify
              ? item.diferencacampoauditoriaitemsistema === 'S'
              : includes(['S', 'N'], item.diferencacampoauditoriaitemsistema)
          )}
          size="small"
          paginate={999999}
          showPagination={false}
        />
      </Form>
    );

  return <div />;
}

ItemDetail.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
